// AddStudent.jsx
import React, { useState } from 'react';
import styles from './AddStudentModal.module.css';
import AddData from '../../components/AddData/AddData';
import IconAndName from '../../components/IconAndName/IconAndName';
import { FaCar } from 'react-icons/fa';

import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';
import ToClose from '../../components/ToClose/ToClose';
import RadioComponent from '../../components/RadioComponent/RadioComponent';
import HeadingAndData from '../../components/HeadingAndData/HeadingAndData';
import HeadingAndDropDown from '../../components/HeadingAndDropDown/HeadingAndDropDown';
import { FaUserPlus, FaMale, FaFemale, FaUser } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';

const AddStudentModal = () => {


    const data = [
  {
    name: 'John Steeve',
    relation: 'Father',
    mobile: '6545654566',
    email: 'gahsjjb@gmail.com',
    address: 'Madhapur,\nHyderabad'
  },
  {
    name: 'Priya Das',
    relation: 'Mother',
    mobile: '9876543210',
    email: 'priyadas@example.com',
    address: 'Banjara Hills,\nHyderabad'
  }
];



  const [gender, setGender] = useState('Male');
  const [studentFirstName, setStudentFirstName] = useState('');
  const [studentLastName, setStudentLastName] = useState('');
  const [room, setRoom] = useState('');
  const [group, setGroup] = useState('');
  const [program, setProgram] = useState('');

  const [fatherName, setFatherName] = useState('');
  const [fatherMobile, setFatherMobile] = useState('');
  const [fatherEmail, setFatherEmail] = useState('');

  const [motherName, setMotherName] = useState('');
  const [motherMobile, setMotherMobile] = useState('');
  const [motherEmail, setMotherEmail] = useState('');

  const dispatch = useDispatch()

  return (
    <div className={styles.container}>
      <div className={styles.AddStudentModal}>
        <div className={styles.header}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Add Student" />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>

        {/* Student Details Section */}
        <div className={styles.sectionBox}>
          <div className={styles.sectionContainer}>
            <div className={styles.sectionHeaderBox}>
              <HeadingAndIcon icon={<FaUser />} heading="Student Details" />
            </div>
            <div className={styles.inputCard}>
              <div className={styles.inputsRow}>
                <HeadingAndData
                  label="Student First Name"
                  name="studentFirstName"
                  placeholder="Enter Student Firstname"
                  value={studentFirstName}
                  onChange={(e) =>
                    /^[a-zA-Z\s]*$/.test(e.target.value) &&
                    setStudentFirstName(e.target.value)
                  }
                  required
                />
                <HeadingAndData
                  label="Student Last Name"
                  name="studentLastName"
                  placeholder="Enter Student Lastname"
                  value={studentLastName}
                  onChange={(e) =>
                    /^[a-zA-Z\s]*$/.test(e.target.value) &&
                    setStudentLastName(e.target.value)
                  }
                  required
                />
                <div className={styles.radioGroup}>
                  <span className={styles.radioLabel}>Gender *</span>
                  <div className={styles.radioOptions}>
                    <RadioComponent
                      name="gender"
                      value="Male"
                      label="Male"
                      checked={gender === "Male"}
                      onChange={(e) => setGender(e.target.value)}
                    />
                    <RadioComponent
                      name="gender"
                      value="Female"
                      label="Female"
                      checked={gender === "Female"}
                      onChange={(e) => setGender(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.inputsRow}>
                <HeadingAndDropDown
                  label="Room"
                  name="room"
                  value={room}
                  onChange={(e) => setRoom(e.target.value)}
                  required
                  options={[
                    { label: "Room 1", value: "room1" },
                    { label: "Room 2", value: "room2" },
                  ]}
                  placeholder="Choose room"
                />
                <HeadingAndDropDown
                  label="Group"
                  name="group"
                  value={group}
                  onChange={(e) => setGroup(e.target.value)}
                  options={[
                    { label: "Group A", value: "groupA" },
                    { label: "Group B", value: "groupB" },
                  ]}
                  placeholder="Choose group"
                />
                <HeadingAndDropDown
                  label="Program"
                  name="program"
                  value={program}
                  onChange={(e) => setProgram(e.target.value)}
                  options={[
                    { label: "Program A", value: "programA" },
                    { label: "Program B", value: "programB" },
                  ]}
                  placeholder="Choose program"
                />
              </div>

              <div className={styles.actionsRow}>
                <SaveAndCancel
                  onSave={() => console.log("Saved")}
                  onCancel={() => console.log("Cancelled")}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Father and Mother Details Side by Side */}
        <div className={styles.detailsRow}>
          {/* Father Details */}
          <div className={styles.sectionBox}>
            <div className={styles.sectionShell}>
              <div className={styles.sectionHeaderBox}>
                <HeadingAndIcon icon={<FaMale />} heading="Father Details" />
              </div>
              <div className={styles.inputCard}>
                <HeadingAndData
                  label="Father Name"
                  name="fatherName"
                  placeholder="Enter Father name"
                  value={fatherName}
                  onChange={(e) =>
                    /^[a-zA-Z\s]*$/.test(e.target.value) &&
                    setFatherName(e.target.value)
                  }
                  required
                />
                <HeadingAndData
                  label="Father Mobile Number"
                  name="fatherMobile"
                  placeholder="Enter Mobile Number"
                  value={fatherMobile}
                  onChange={(e) =>
                    /^\d{0,10}$/.test(e.target.value) &&
                    setFatherMobile(e.target.value)
                  }
                  required
                />
                <HeadingAndData
                  label="Father Email ID"
                  name="fatherEmail"
                  placeholder="Enter Email"
                  type="email"
                  value={fatherEmail}
                  onChange={(e) => setFatherEmail(e.target.value)}
                />
                <SaveAndCancel
                  onSave={() => console.log("Saved Father")}
                  onCancel={() => console.log("Cancelled Father")}
                />
              </div>
            </div>
          </div>

          {/* Mother Details */}
          <div className={styles.sectionBox}>
            <div className={styles.sectionShell}>
              <div className={styles.sectionHeaderBox}>
                <HeadingAndIcon icon={<FaFemale />} heading="Mother Details" />
              </div>
              <div className={styles.inputCard}>
                <HeadingAndData
                  label="Mother Name"
                  name="motherName"
                  placeholder="Enter Mother name"
                  value={motherName}
                  onChange={(e) =>
                    /^[a-zA-Z\s]*$/.test(e.target.value) &&
                    setMotherName(e.target.value)
                  }
                  required
                />
                <HeadingAndData
                  label="Mother Mobile Number"
                  name="motherMobile"
                  placeholder="Enter Mobile Number"
                  value={motherMobile}
                  onChange={(e) =>
                    /^\d{0,10}$/.test(e.target.value) &&
                    setMotherMobile(e.target.value)
                  }
                  required
                />
                <HeadingAndData
                  label="Mother Email ID"
                  name="motherEmail"
                  placeholder="Enter Email"
                  type="email"
                  value={motherEmail}
                  onChange={(e) => setMotherEmail(e.target.value)}
                />
                <SaveAndCancel
                  onSave={() => console.log("Saved Mother")}
                  onCancel={() => console.log("Cancelled Mother")}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.rowWrapper}>
          <HeadingAndIcon icon={<FaCar />} heading="Authorized pick up" />
          <IconAndName icon="+" title="Add pick up" />
        </div>

        <div>
          <AddData data={data} />
        </div>
      </div>
    </div>
  );
};

export default AddStudentModal;